import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ChecklistImage } from './type';
import { ChecklistImageApiService } from '../infra/api.service';

@Injectable({ providedIn: 'root', useClass: ChecklistImageApiService })
export abstract class ChecklistImageService {
  abstract replaceFile(id: number, file: File): Observable<ChecklistImage>;
}
